import {
  SET_PERSONAL_FILTER,
  SET_ENTERPRISE_FILTER,
  SET_PROJECT_FILTER
} from './mutation-types.js'

export default {
  [SET_PERSONAL_FILTER] (state, personalFilter) {
    state.personalFilter = personalFilter
  },
  [SET_ENTERPRISE_FILTER] (state, enterpriseFilter) {
    state.enterpriseFilter = enterpriseFilter
  },
  [SET_PROJECT_FILTER] (state, projectFilter) {
    state.projectFilter = projectFilter
  }
}

